// extracted by extract-css-chunks-webpack-plugin
module.exports = {"body":"body___3R0dN","wrapper":"wrapper___zIJHp","subtitle":"subtitle___O8uVK","buttons":"buttons___25rkh","submit":"submit___1_MsA"};